import { REQUEST_DELETE_USER, REQUEST_DELETE_USER_FAILED, REQUEST_DELETE_USER_SUCCESS, REQUEST_EMAIL_VERIFICATION, REQUEST_EMAIL_VERIFICATION_FAILED, REQUEST_EMAIL_VERIFICATION_SUCCESS } from './Constant';

// userReducer.js
const initialState = {
    user: null,
    loading: false,
    error: null,
};
  
export const deleteAccountReducer = (state = initialState, action) => {
    switch (action.type) {
    case REQUEST_DELETE_USER:
        console.log('action', action);
        
        return { ...state, loading: true };
    case REQUEST_DELETE_USER_SUCCESS :        
        return { ...state, deleteUserDetails : action.payload, verificationDetails : null, loading: false };
    case REQUEST_DELETE_USER_FAILED :
        return { ...state,loading: false };
    case REQUEST_EMAIL_VERIFICATION:
        return { ...state, loading: true };
    case REQUEST_EMAIL_VERIFICATION_SUCCESS :        
        return { ...state, verificationDetails : action.payload, deleteUserDetails : null, loading: false };
    case REQUEST_EMAIL_VERIFICATION_FAILED :
        return { ...state,loading: false };
    default:
        return state;
    }
};
  